export default "__VITE_ASSET__GEcv5ZMo__"